import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";
import { useToastStore } from "../../Common/ToastProvider/store/useToastStore";
import { MESSAGES } from "../utils/strings";

export function useToastOnCopy(message = "",isError = false,externalTrigger = null) {
  message = message || MESSAGES.NOTE_COPY_TO_CLIPBOARD;
  const location = useLocation();
  const navigate = useNavigate();
  const enqueueToast = useToastStore((state) => state.enqueueToast);
  const backgroundColor = isError ? HNSColors.failure[800] : HNSColors.secondary[950];
  const errorIcon = <Svg
    name={SvgEnum.HisAlertCircle}
    color={HNSColors.failure[500]}
    sx={{
      height: "30px",
      width: "30px",
    }}
  />; 
  const handleOpenToast = useCallback(() => {
    enqueueToast({
      message,
      textColor: isError ? HNSColors.failure[400] : HNSColors.primary[200],
      backgroundColor,
      duration: 2000,
      icon: isError ? errorIcon : (
        <Svg
          name={SvgEnum.HisCheckCircle2}
          color={HNSColors.secondary[500]}
          sx={{
            height: "30px",
            width: "30px",
          }}
        />
      ),
    });
  }, [enqueueToast, message, isError]);

  useEffect(() => {
    if (location.state?.triggerToast) {
      handleOpenToast();
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate, handleOpenToast]);
  useEffect(() => {
    if (externalTrigger) {
      handleOpenToast();
    }
  }, [externalTrigger, handleOpenToast]);
}
